<template>
  <div class="details_section">
    <h4 class="details_section--header text-uppercase">{{heading}}</h4>
    <slot/>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "DetailSection",
  props: {
    heading: {
      type: String,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.details_section {
  margin-top: 16px;

  &:first-of-type {
    margin-top: 8px;
  }

  &--header {
    margin-bottom: 4px;
    font-size: 0.625rem;
  }

  p {
    margin-bottom: 4px;
  }
}
</style>
